/**
 * Kanban Constants
 */
// Constants for public events
/** @private */
export var actionBegin = 'actionBegin';
/** @private */
export var actionComplete = 'actionComplete';
/** @private */
export var actionFailure = 'actionFailure';
/** @private */
export var cardClick = 'cardClick';
/** @private */
export var cardDoubleClick = 'cardDoubleClick';
/** @private */
export var cardRendered = 'cardRendered';
/** @private */
export var queryCellInfo = 'queryCellInfo';
/** @private */
export var dataBinding = 'dataBinding';
/** @private */
export var dataBound = 'dataBound';
/** @private */
export var dragStart = 'dragStart';
/** @private */
export var drag = 'drag';
/** @private */
export var dragStop = 'dragStop';
/** @private */
export var documentClick = 'document-click';
/** @private */
export var dialogOpen = 'dialogOpen';
/** @private */
export var dialogClose = 'dialogClose';
// Constants for internal events
/** @private */
export var contentReady = 'content-ready';
/** @private */
export var dataReady = 'data-ready';
/** @private */
export var bottomSpace = 25;
/** @private */
export var cardSpace = 16;
/** @private */
export var toggleWidth = 50;
/** @hidden */
export var dataSourceChanged = 'dataSourceChanged';
/** @hidden */
export var dataStateChange = 'dataStateChange';
